export default {
      id: "ic-betslip-settings-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic-betslip-settings-usage",
      toString: function () {
        return this.url;
      }
    }